import { useState, useEffect } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/button/Button'
import { permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import '../course/viewCourseList.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { Box, Typography } from '@mui/material'
import RightDrawer from '../../components/drawer/Drawer'
import * as Yup from 'yup'
import { ErrorMessage, Formik } from 'formik'
import NewInput from '../../components/input/NewInput'
import closeIcon from '../../assets/icons/close.svg'
import './inventory.scss'
import { Dropdown } from 'primereact/dropdown'
import PopupBox from '../../components/popup/PopupBox'
import HorizontalLine from '../../assets/icons/Line33.svg'
import ModalUnstyled from '../../components/model/Model'
import {
  capitalizeFirstLetter,
  dynamicCustomFilter,
  handleInput,
  handleInputString,
  handleInventory,
} from '../../utility/genricFunction'
import {
  addInventory,
  getInventory,
  getInventoryHistory,
  mangeInventory,
  editInventory,
} from '../../store/builders/inventory/inventory.builder'
import AddInventoryIcon from '../../assets/icons/FileExport1.svg'
import inventoryHistoryIcon from '../../assets/icons/TakeFollowUp.svg'
import pencilIcon from '../../assets/icons/pencil1.svg'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'

const InventoryHistory = ({ data }) => {
  const dispatch = useDispatch()
  const inventoryHistory = useSelector((state) => state?.inventory?.inventoryHistory)

  useEffect(() => {
    if (data.materialId) {
      dispatch(getInventoryHistory(data?.materialId))
    }
  }, [data?.materialId, dispatch])

  return (
    <div className='inventory-history-wrapper'>
      <div className='history-table-wrapper'>
        <table className='inventory-history-table' >
          <tr className='inventory-history-table-header' >
            <td className='table-quantity-row' >Quantity</td>
            <td>Branch</td>
          </tr>

          {
            inventoryHistory?.length > 0 && inventoryHistory.map((inventory, i) => {
              return <tr key={i}>
                <td className='quantity-display'>{inventory?.branchQuantity}</td>
                <td>{inventory?.branch?.branchName}</td>
              </tr>
            })
          }
        </table>
      </div>
    </div>
  )
}

const Inventory = () => {
  const dispatch = useDispatch()
  const roleSelector = useSelector((store) => store.auth)
  const userRole = roleSelector?.user?.result?.userData?.roleName
  const [isOpen, setIsOpen] = useState(false)
  const { loading, inventoryData } = useSelector((state) => state.inventory)
  const [archiveId, setArchiveId] = useState('')
  const [singleInventoryData, setSingleInventoryData] = useState('')

  // const { branchList } = useSelector((store) => {
  //   return store.course
  // })

  const branchList = useSelector((store) => store.branch.branchTableData)

  const branches = branchList.map((branch) => {
    return { label: branch.branchName, value: branch.branchId }
  })

  const handleBranchDropdownChange = (value, setFieldValue) => {
    setFieldValue('branchName', value)
  }

  useEffect(() => {
    dispatch(getInventory())
    return () => dispatch({ type: 'inventory/clearExtraReducers' })
  }, [])

  const numbers = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
  ]
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    materialName: { value: null, matchMode: 'dynamic_custom' },
    quantity: { value: null, matchMode: 'dynamic_custom' },
    branch: { value: null, matchMode: FilterMatchMode.CONTAINS },
    representative: { value: null, matchMode: FilterMatchMode.CONTAINS },
    materialStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [open, setOpen] = useState(false)
  const [inventoryDrawerOpen, setInventoryDrawerOpen] = useState(false)
  const [editInventoryDrawer, setEditInventoryDrawer] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  useEffect(() => {
    setFilteredData(inventoryData)
  }, [inventoryData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(inventoryData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleDrawerForAddInventory = (newOpen, inventoryData) => () => {
    setInventoryDrawerOpen(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inventoryData)
  }

  const toggleDrawerForEditInventory = (newOpen, inventoryData) => () => {
    setEditInventoryDrawer(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inventoryData)

  }

  const handleArchive = (inventoryData) => {
    setArchiveId(inventoryData)
    setOpenArchive(true)
    setIsOpen(true)
  }

  const [classNoState] = useState('')
  const [clientNameState] = useState('')
  const [selectedValue, setSelectedValue] = useState(null)
  const [addInventoryQuantity] = useState('')



  const statuses = [
    { label: 'active', value: 'active' },
    { label: 'inactive', value: 'inactive' },
  ]

  const validationSchema = Yup.object().shape({
    materialName: Yup.string().required(VALIDATION_MESSAGES.INVENTORY_NAME_REQUIRED),
    quantity: Yup.string().required(VALIDATION_MESSAGES.QUANTITY_REQUIRED),
  })

  const handleFormSubmit = () => {
    setOpen(false)
  }

  const DrawerList = (
    <Box className='timetable-drawer' role='presentation'>
      <Box className='timetable-drawer-header flex justify-between align-center'>
        <Typography className='timetable-drawer-title'>{UI_CONSTANT.INVENTORY.ADD_INVENTORY}</Typography>
        <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={toggleDrawer(false)} />
      </Box>
      <Box className='drawer-horizontal-line' />

      <Formik
        initialValues={{
          quantity: classNoState,
          materialName: clientNameState,
        }}
        validationSchema={validationSchema}
        onSubmit={(value) => {
          handleFormSubmit()
          dispatch(addInventory(value))
        }}
      >
        {({ handleSubmit }) => (
          <form>
            <div className='full-form'>
              <div className='first-row'>
                <NewInput
                  label='Inventory Name'
                  placeholder='Enter inventory name'
                  name='materialName'
                  width={'50%'}
                  required={true}
                  onInput={handleInventory}
                />
                <NewInput
                  label='Inventory Quantity'
                  placeholder='Enter inventory quantity'
                  name='quantity'
                  width={'50%'}
                  type={'number'}
                  required={true}
                  onInput={handleInput}
                />
              </div>
            </div>

            <div className='right-drawer-save'>
              <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                {UI_CONSTANT.SUBMIT}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Box>
  )

  const handleManageInventoryFormSubmit = (value) => {
    dispatch(mangeInventory(value))
    setInventoryDrawerOpen(false)
  }

  const InventoryDrawerList = (data) => {
    const manageInventoryValidationSchema = Yup.object().shape({
      branchName: Yup.string().required('Branch Name is required'),
      branchMaterialQuantity: Yup.number()
        .required('Quantity is required')
        .max(data?.data?.quantity, `Quantity should not be greater than ${data?.data?.quantity}`),
    })

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>Manage Inventory</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForAddInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            branchMaterialQuantity: addInventoryQuantity,
            materialId: data?.data?.materialId,
            branchName: '',
          }}
          validationSchema={manageInventoryValidationSchema}
          onSubmit={(value) => {
            handleManageInventoryFormSubmit(value)
          }}
        >
          {({ values, handleSubmit, setFieldValue }) => (
            <form>
              <div className='full-form'>
                <div className='first-row'>
                  <NewInput
                    label='Inventory Quantity'
                    placeholder='Enter inventory quantity'
                    name='branchMaterialQuantity'
                    width={'50%'}
                    type={'number'}
                    required={true}
                    onInput={handleInput}
                  />

                  <div className='first-field w-50'>
                    <label className='branch-title-inp padding-top-0' htmlFor=''>
                      Branch
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={branches}
                      selectedValue={values.branchName}
                      className={'branch-dropdown'}
                      onChange={(e) => handleBranchDropdownChange(e.target.value, setFieldValue)}
                      name={'branchName'}
                      placeholder={'Select branch'}
                    />
                    <ErrorMessage name='branchName' component='div' className='error-msg' />
                  </div>
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const handleEditInventoryFormSubmit = (value) => {
    dispatch(editInventory(value))
    setEditInventoryDrawer(false)
  }

  const EditInventoryDrawerList = (data) => {
    const editInventoryValidationSchema = Yup.object().shape({
      branchMaterialQuantity: Yup.string().required('Quantity is required'),
    })

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>{UI_CONSTANT.INVENTORY.EDIT_INVENTORY}</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForEditInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            branchMaterialQuantity: data?.data?.quantity,
            materialId: data?.data?.materialId,
            materialName: data?.data?.materialName,
          }}
          validationSchema={editInventoryValidationSchema}
          onSubmit={(value) => {
            handleEditInventoryFormSubmit(value)
          }}
        >
          {({ values, handleSubmit }) => (
            <form>
              <div className='full-form'>
                <div className='first-row'>
                  <NewInput
                    label='Material name'
                    // placeholder={`${data.data.materialName}`}
                    name='materialName'
                    width={'50%'}
                    value={values.materialName}
                    required={true}
                    onInput={handleInputString}
                    disabled={true}
                  />
                  <NewInput
                    label='Inventory Quantity'
                    placeholder='Enter inventory quantity'
                    name='branchMaterialQuantity'
                    width={'50%'}
                    type={'number'}
                    required={true}
                    onInput={handleInput}
                  />
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const nameBody = (inventoryData) => {
    const representative = inventoryData?.materialName && capitalizeFirstLetter(inventoryData?.materialName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const statusBody = (inventoryData) => {
    const representative = inventoryData?.materialStatus && capitalizeFirstLetter(inventoryData?.materialStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        // itemTemplate={statusItemTemplate}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
      // style={{ minWidth: '12rem' }}
      />
    )
  }

  const verifiedBodyTemplate = (inventoryData) => {

    return (
      <>
        <PopupBox rowData={inventoryData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            <img src={HorizontalLine} alt='' />
            {UseAuthorization(permissions.ADD_INVENTORY_TO_BRANCH) && <button className='div-assign-to-branch' onClick={toggleDrawerForAddInventory(true, inventoryData)}>
              <img src={AddInventoryIcon} alt="" /><p className='verifiedBodyTemplate-darkfont'>Add inventory to branch</p>
            </button>}


            {UseAuthorization(permissions.EDIT_INVENTORY) && (
              <button className='div-assign-to-branch' onClick={toggleDrawerForEditInventory(true, inventoryData)}>
                <img src={pencilIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>Edit inventory</p>
              </button>
            )}

            {UseAuthorization(permissions.INVENTORY_HISTORY) && (
              <button className='div-assign-to-branch' onClick={() => handleArchive(inventoryData)}>
                <img src={inventoryHistoryIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>Inventory history</p>
              </button>
            )}
          </div>
        </PopupBox>

        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            title={archiveId?.materialName}
            setOpen={setOpenArchive}
            className={'inventory-model'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            inventoryHistory={true}
          >
            <InventoryHistory data={archiveId} setOpenArchive={setOpenArchive} />
          </ModalUnstyled>
        )}
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'materialName',
      header: 'Inventory Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'quantity',
      header: 'Quantity',
      style: { minWidth: '8rem' },
      filter: true,
      filterPlaceholder: 'Search by quantity...',
    },
    {
      sortable: true,
      field: 'materialStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { width: '5rem' },
      style: { minWidth: '5rem' },
      filterPlaceholder: 'Search by status...',
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ].filter((column) => {
    if (column.field.toLowerCase() == 'verified' && userRole.toLowerCase() == UI_CONSTANT.BRANCH_ROLE) {
      return false
    } else {
      return true
    }
  })

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.INVENTORY.LABEL_INVENTORY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.INVENTORY.LABEL_INVENTORY,
      link: ROUTES_PATH.INVENTORY,
    },
  ]

  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {loading && <Loader loading={loading} />}

      <div className={`course-list }`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            {/* {userRole === 'admin' && UseAuthorization('ADD_INVENTORY') && ( */}
            {UseAuthorization(permissions.ADD_INVENTORY) && (
              <Button className='add-btn' onClick={toggleDrawer(true)}>
                {UI_CONSTANT.INVENTORY.ADD_INVENTORY}
              </Button>
            )}
          </div>
          <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
            {DrawerList}
          </RightDrawer>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>{UI_CONSTANT.INVENTORY.ALL_INVENTORY}</b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>

          <div id='inventory-list-table' className='table-card'>
            <ParentDataTable
              value={filteredData}
              rows={filterNumber ? filteredData.length : selectedNumber}
              filters={filters}
              // loading={loading}
              columns={columns}
              onFilter={onFilter}
            />
          </div>
        </div>
        {/* </div> */}
        {inventoryDrawerOpen && (
          <RightDrawer anchor='right' isOpen={inventoryDrawerOpen} onClose={toggleDrawerForAddInventory(false)}>
            <InventoryDrawerList data={singleInventoryData} />
          </RightDrawer>
        )}
        {editInventoryDrawer && (
          <RightDrawer anchor='right' isOpen={editInventoryDrawer} onClose={toggleDrawerForEditInventory(false)}>
            <EditInventoryDrawerList data={singleInventoryData} />
          </RightDrawer>
        )}
      </div>
    </>
  )
}

export default Inventory
